import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Image, QcropModel, UiTemplate } from '../../model/qcrop.model';
import { select, Store } from '@ngrx/store';
import { qcropActions } from '../actions/qcrop.actions';
import { qcropFeature } from '../features/qcrop.feature';
import { FocalPoint } from '../../features/focal-point/model/focal-point.model';

@Injectable({
  providedIn: 'root',
})
export class QcropFacade {
  _qcrop$: Observable<QcropModel | null> = this.store.pipe(
    select(qcropFeature.select_qcrop)
  );

  image$: Observable<Image | null> = this.store.pipe(
    select(qcropFeature.selectImage)
  );

  modified$: Observable<boolean> = this.store.pipe(
    select(qcropFeature.selectModified)
  );

  loading$: Observable<boolean> = this.store.pipe(
    select(qcropFeature.selectLoading)
  );

  token$: Observable<string | null> = this.store.pipe(
    select(qcropFeature.selectToken)
  );

  constructor(private store: Store) {}

  initQcrop(
    assetId: string,
    companyId: string | null,
    token: string | null
  ): void {
    this.setCompanyId(companyId);
    this.setActiveAssetId(assetId);
    this.setToken(token);
    this.loadQcrop();
  }

  setActiveAssetId(assetId: string): void {
    this.store.dispatch(qcropActions.setActiveAssetId({ assetId }));
  }

  loadQcrop(): void {
    this.store.dispatch(qcropActions.getQcrop());
  }

  resetQcrop(): void {
    this.store.dispatch(qcropActions.reload_qcrop());
  }

  saveQcrop(): void {
    this.store.dispatch(qcropActions.saveQcrop());
  }

  setImage(image: Image): void {
    this.store.dispatch(qcropActions.setImage({ image }));
  }

  modifyTemplate(uiTemplate: UiTemplate, index: number): void {
    this.store.dispatch(qcropActions.modifyUiTemplate({ uiTemplate, index }));
  }

  toggleVisibilityTemplates(visible: boolean): void {
    this.store.dispatch(
      qcropActions.toggleVisibilityAllUiTemplates({ visible })
    );
  }

  autoGenerateFrame(...templateIds: string[]): void {
    this.store.dispatch(qcropActions.autoGenerateFrames({ templateIds }));
  }

  modifyFocalPoint(focalPoint: FocalPoint, index: number): void {
    this.store.dispatch(qcropActions.modifyFocalPoint({ focalPoint, index }));
  }

  setActiveFocalPoint(focalPoint: FocalPoint, index: number): void {
    this.store.dispatch(
      qcropActions.setActiveFocalPoint({ focalPoint, index })
    );
  }

  setActiveTemplate(uiTemplate: UiTemplate, index: number): void {
    this.store.dispatch(qcropActions.setActiveFrame({ uiTemplate, index }));
  }

  removeFocalPoint(index: number): void {
    this.store.dispatch(qcropActions.removeFocalPoint({ index }));
  }

  addFocalPoint(focalPoint: FocalPoint): void {
    this.store.dispatch(qcropActions.addFocalPoint({ focalPoint }));
  }

  toggleVisibilityFocalPoints(visible: boolean): void {
    this.store.dispatch(
      qcropActions.toggleVisibilityAllFocalPoints({ visible })
    );
  }

  setCompanyId(companyId: string | null): void {
    this.store.dispatch(qcropActions.setCompanyId({ companyId }));
  }

  setToken(token: string | null): void {
    this.store.dispatch(qcropActions.setToken({ token }));
  }
}
